import type { AvatarProps } from '@mui/material/Avatar';

import { Or2Image } from '../image/Or2Image';

import { Or2Avatar } from './Or2Avatar';

interface Props extends AvatarProps {
  iconUrl: string | null | undefined;
  groupOrServiceName: string | null | undefined;
  size?: number;
}

export const GroupOrServiceAvatar = ({
  iconUrl,
  groupOrServiceName,
  size,
  sx,
  ...otherProps
}: Props) => {
  const name = groupOrServiceName ?? '';

  const sxProp = {
    ...sx,
    width: size,
    height: size,
  };

  return iconUrl ? (
    <Or2Avatar
      sx={{ ...sxProp, backgroundColor: 'transparent' }}
      {...otherProps}
    >
      {size === undefined ? (
        <Or2Image fill src={iconUrl} alt={name} />
      ) : (
        <Or2Image size={size} src={iconUrl} alt={name} />
      )}
    </Or2Avatar>
  ) : (
    <Or2Avatar sx={{ ...sxProp, backgroundColor: 'letterAvatarBackground' }}>
      {name.charAt(0)}
    </Or2Avatar>
  );
};
